/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProceedingParticipantRequest
 */
export interface UpdateProceedingParticipantRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProceedingParticipantRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the UpdateProceedingParticipantRequest interface.
 */
export function instanceOfUpdateProceedingParticipantRequest(value: object): value is UpdateProceedingParticipantRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function UpdateProceedingParticipantRequestFromJSON(json: any): UpdateProceedingParticipantRequest {
    return UpdateProceedingParticipantRequestFromJSONTyped(json, false);
}

export function UpdateProceedingParticipantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProceedingParticipantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'country': json['country'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'note': json['note'],
    };
}

export function UpdateProceedingParticipantRequestToJSON(json: any): UpdateProceedingParticipantRequest {
    return UpdateProceedingParticipantRequestToJSONTyped(json, false);
}

export function UpdateProceedingParticipantRequestToJSONTyped(value?: UpdateProceedingParticipantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'country': value['country'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'note': value['note'],
    };
}

